export default __webpack_public_path__ + "static/pt_sam42_administration-833d9cd40b737a62420b2ed6c9d07bfc.jpg";